import { useQueryParams } from "@certn/api";
import { Picker } from "@certn/cascadia-react";
import React from "react";

interface BillingProfileNameFilterProps {
  billingProfileNameOptions: { id: string; name: string }[];
}

export function BillingProfileNameFilter(props: BillingProfileNameFilterProps) {
  const { setParam, flatParams } = useQueryParams();
  const filterKey = "billing_profile_ids";

  return (
    <Picker
      showActionBar
      selectedKeys={
        flatParams[filterKey]
          ? flatParams[filterKey].split(",").filter(Boolean)
          : []
      }
      onSelectionChange={(keys) => {
        setParam(filterKey, Array.from(keys).map(String), true);
      }}
      label="Billing profile"
      items={props.billingProfileNameOptions}
      selectionMode="multiple"
      testID="billing-profile-filter"
    />
  );
}
